import { FC } from 'react'
import { cn } from '@wellesley/ui'

import { PopupAlignment } from './types'

const arrowLineAlignmentClass: Record<PopupAlignment, string> = {
  left: 'left-[20px]',
  right: 'right-[20px]',
  center: 'left-[calc(50%-6.5px)]',
}

const arrowContainerAlignmentClass: Record<PopupAlignment, string> = {
  left: 'left-[18px]',
  right: 'right-[18px]',
  center: 'left-1/2 -translate-x-1/2',
}

const PopupArrow: FC<{ alignment: PopupAlignment }> = ({ alignment }) => (
  <>
    <span
      className={cn(
        'absolute -top-[16px] z-[3] h-[1px] w-[13px] bg-white',
        arrowLineAlignmentClass[alignment],
      )}
    />
    <div
      className={cn(
        'absolute top-[-15px] z-[2] h-[11px] w-[16px] rotate-180 overflow-hidden border-t border-white bg-white',
        arrowContainerAlignmentClass[alignment],
      )}
    >
      <div className="absolute left-1/2 top-[-15px] z-[2] h-[11px] w-[16px] -translate-x-1/2 rotate-180 overflow-hidden border-t border-white bg-white" />
      <span className="absolute bottom-0 left-0 h-[11px] w-[8px] origin-bottom-left rotate-45 border-b border-l border-gray-200" />
      <span className="absolute bottom-0 right-0 h-[11px] w-[8px] origin-bottom-right -rotate-45 border-b border-r border-gray-200" />
    </div>
  </>
)

export default PopupArrow
